export const pageTitle = "Le Maître de la Guitare™ — 2 livres + 5 bonus pour professeurs de guitare";
export const supportEmail = "support@stockdigital.shop";

export const mockupImage = "https://cdn.magicpatterns.com/uploads/e2vwsVuytGc96z6h2ushRD/Paquete_premium_para_profesores_de_guitarra.png";

export const heroChips = ["2 livres", "5 bonus offerts", "100 % PDF", "Prêt à imprimer"];

export const trustStats = [
  { value: "2 + 5", label: "Livres & bonus" },
  { value: "PDF", label: "Prêt à imprimer" },
  { value: "E-mail", label: "Livraison après l'achat" },
  { value: "10 jours", label: "Satisfait ou remboursé" },
];

export const problems = [
  { title: "Préparer chaque cours de zéro", desc: "Vous passez des heures sur YouTube et les sites de tablatures à chercher quoi enseigner." },
  { title: "Toujours les mêmes fiches", desc: "Vous redistribuez les mêmes fiches d'accords parce que vous n'avez plus de matériel nouveau." },
  { title: "Arriver sans plan clair", desc: "Vous commencez le cours sans savoir exactement ce que vous allez faire travailler." },
  { title: "Des élèves qui décrochent", desc: "Vos élèves s'ennuient et abandonnent avant d'avoir joué leur premier morceau." },
];

export const usageSteps = [
  { title: "Ouvrez", desc: "Ouvrez le livre ou le bonus dont vous avez besoin, sur ordinateur, tablette ou téléphone." },
  { title: "Choisissez", desc: "Choisissez la notion, l'exercice, la tablature ou la fiche adaptée au niveau de votre élève." },
  { title: "Enseignez", desc: "Imprimez la page ou affichez-la sur tablette, et apportez-la à votre prochain cours." },
];

export const books = [
  {
    label: "LIVRE 1 · POUR VOUS",
    title: "Le livre théorique",
    subtitle: "Votre guide du professeur",
    desc: "Ouvrez-le pour revoir une notion et préparer votre explication avant le cours.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/a763eed1-c019-4e10-842a-6c66068c639a.jpg",
  },
  {
    label: "LIVRE 2 · POUR VOS ÉLÈVES",
    title: "Le livre pratique",
    subtitle: "Les exercices pour vos élèves",
    desc: "Choisissez un exercice, imprimez-le et faites-le travailler en cours.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/4b62b9da-435c-4386-ab50-fd5985bb4fd1.jpg",
  },
];

/** Add real interior pages here (image URL + short caption). The section stays hidden while this list is empty. */
export const samplePages: { image: string; title: string; caption: string }[] = [
  {
    image: "https://cdn.magicpatterns.com/uploads/spN4t1xKFTBLxCsmWf819M/02_araignee_R1.png",
    title: "R1 · Araignée 1-2-3-4",
    caption: "Indépendance et doigté en position 5, avec tempo, consignes de répétition et suivi sur 3 semaines.",
  },
  {
    image: "https://cdn.magicpatterns.com/uploads/gUmSR6N4jmviYNqQGNAHBe/03_chromatique_R31.png",
    title: "R31 · Échelle chromatique classique",
    caption: "Chromatique ascendante en position 2, avec le doigté indiqué sous chaque note.",
  },
  {
    image: "https://cdn.magicpatterns.com/uploads/bZd354eiQqzwUy2yJEGBN9/04_arpege_brise_R27.png",
    title: "R27 · Arpège brisé G-B-e",
    caption: "Arpège ascendant en croches avec les doigts 1-2-3, sur les trois cordes aiguës.",
  },
  {
    image: "https://cdn.magicpatterns.com/uploads/rKqJnabYU49gC76mcEMExi/05_grand_final_R50.png",
    title: "R50 · Grand final : toutes les techniques",
    caption: "L'exercice le plus difficile du bonus, pour réunir tout ce qui a été travaillé.",
  },
];

export const bonuses = [
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/e5616766-9fcc-43b8-8e77-ace9082cfc69.jpg",
    title: "La bibliothèque de tablatures pour débuter",
    desc: "Des tablatures accessibles aux débutants, prêtes à imprimer et à distribuer dès le premier cours.",
  },
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/0b82cd07-27a7-4c7f-82eb-847ce4d917c5.jpg",
    title: "Le guide des mélodies pour débutants",
    desc: "Des mélodies simples pour que vos nouveaux élèves jouent quelque chose de reconnaissable dès les premières semaines.",
  },
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/68f20178-b5c0-413f-a91d-3cd598c183c6.jpg",
    title: "Le calendrier d'exercices sur 30 jours",
    desc: "Un plan de pratique jour par jour à envoyer à la maison, pour que l'élève progresse entre deux cours.",
  },
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/001dc7ab-c103-411a-ba00-557c6ca96d11.jpg",
    title: "Le pack d'exercices techniques",
    desc: "Des exercices de doigté, de médiator et de changements d'accords, classés par niveau de difficulté.",
  },
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/3aabd506-d90f-437d-a14c-cbffb53a835e.jpg",
    title: "Les fiches de cours prêtes à l'emploi",
    desc: "Des fiches avec objectifs, exercices et devoirs, à imprimer telles quelles ou à adapter à votre élève.",
  },
];

export const offerList = [
  "Le livre théorique — le guide du professeur",
  "Le livre pratique — pour vos élèves",
  "Bonus 01 · La bibliothèque de tablatures pour débuter",
  "Bonus 02 · Le guide des mélodies pour débutants",
  "Bonus 03 · Le calendrier d'exercices sur 30 jours",
  "Bonus 04 · Le pack d'exercices techniques",
  "Bonus 05 · Les fiches de cours prêtes à l'emploi",
  "Tout en PDF à télécharger et à imprimer",
];

export const faqs = [
  { q: "Que contient exactement le pack ?", a: "2 livres — le livre théorique (le guide du professeur) et le livre pratique (pour vos élèves) — et 5 bonus offerts : la bibliothèque de tablatures pour débuter, le guide des mélodies pour débutants, le calendrier d'exercices sur 30 jours, le pack d'exercices techniques et les fiches de cours prêtes à l'emploi." },
  { q: "Comment l'utiliser en cours ?", a: "Ouvrez le livre théorique pour préparer votre explication, choisissez un exercice dans le livre pratique ou dans les bonus, imprimez-le et apportez-le à votre cours. Vous pouvez aussi l'afficher sur tablette." },
  { q: "Pour quel niveau d'élèves ?", a: "Les bonus sont pensés pour les élèves débutants : premières tablatures, premières mélodies, exercices classés par niveau. Vous choisissez ensuite ce qui convient à chaque élève." },
  { q: "Est-ce un livre physique ?", a: "Non. Tout est 100 % numérique, en PDF — sans vidéos ni livres audio. Vous pouvez lire les fichiers à l'écran ou les imprimer." },
  { q: "Comment vais-je recevoir le matériel ?", a: "Juste après votre paiement, vous recevez un e-mail avec le lien pour télécharger les 2 livres et les 5 bonus en PDF." },
  { q: "De quoi ai-je besoin pour l'utiliser ?", a: "D'un ordinateur, d'une tablette ou d'un téléphone pour ouvrir les PDF, et d'une imprimante si vous souhaitez distribuer les pages sur papier." },
  { q: "Comment se passe le paiement ?", a: "Paiement unique de 29 € par carte bancaire, sur une page de paiement sécurisée. Aucun abonnement." },
  { q: "Et si le pack ne me convient pas ?", a: `Vous êtes couvert par notre garantie satisfait ou remboursé de 10 jours. Un simple e-mail à ${supportEmail} suffit, sans aucune question.` },
];

export const withoutList = [
  "Des heures chaque semaine à chercher des tablatures et des fiches",
  "Des cours improvisés à la dernière minute",
  "Toujours les mêmes fiches d'accords",
  "Des élèves qui abandonnent avant leur premier morceau",
];

export const withList = [
  "Vous ouvrez, vous choisissez, vous enseignez",
  "Du matériel prêt à imprimer pour chaque cours",
  "Des tablatures et des mélodies qu'ils ont envie de jouer",
  "Un calendrier de 30 jours pour progresser entre les cours",
];
